"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CreatableSelectNode = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _reactSelect = require("react-select");
var _chevronDown = _interopRequireDefault(require("@spothero/icons/chevron-down"));
var _react2 = require("@chakra-ui/react");
var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownIndicator = props => {
  const {
    sizes
  } = (0, _react2.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "CreatableSelect-dropdown-icon",
    as: _chevronDown.default,
    boxSize: sizes['2.5']
  }));
};

// Exporting without forwardRef for storybook to work
const CreatableSelectNode = ({
  id,
  label,
  isInvalid = false,
  isLoading = false,
  isRequired,
  options = [],
  placeholder = '',
  errorMessage,
  helperText,
  innerRef,
  ...props
}) => {
  const {
    colors,
    fontSizes
  } = (0, _react2.useTheme)();
  if (innerRef) {
    props.ref = innerRef;
  }
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200'],
      borderWidth: '1px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200']
      }
    }),
    placeholder: provided => ({
      ...provided,
      fontSize: fontSizes.sm,
      color: colors.gray['200']
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: colors.brandBlue,
      '&:hover': {
        color: colors.brandBlue
      }
    }),
    indicatorSeparator: provided => ({
      ...provided,
      display: 'none'
    })
  };
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    isInvalid: isInvalid,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/_react.default.createElement(_creatable.default, (0, _extends2.default)({
    id: id,
    components: {
      DropdownIndicator
    },
    styles: customStyles,
    options: options,
    placeholder: placeholder,
    isLoading: isLoading
  }, props)));
};
exports.CreatableSelectNode = CreatableSelectNode;
const CreatableSelect = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    id,
    label,
    isInvalid = false,
    isLoading = false,
    isRequired,
    options = [],
    placeholder = '',
    errorMessage,
    helperText,
    ...additionalProps
  } = props;
  return /*#__PURE__*/_react.default.createElement(CreatableSelectNode, (0, _extends2.default)({
    id: id,
    innerRef: ref,
    label: label,
    options: options,
    placeholder: placeholder,
    helperText: helperText,
    errorMessage: errorMessage,
    isLoading: isLoading,
    isInvalid: isInvalid,
    isRequired: isRequired
  }, additionalProps));
});
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => /*#__PURE__*/_react.default.createElement(CreatableSelectNode, (0, _extends2.default)({
  ref: ref
}, props)));